import { render, staticRenderFns } from "./searchExams.view.vue?vue&type=template&id=0af5ad80"
import script from "./searchExams.view.vue?vue&type=script&lang=js"
export * from "./searchExams.view.vue?vue&type=script&lang=js"
import style0 from "./searchExams.view.vue?vue&type=style&index=0&id=0af5ad80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports